const FormLabel = {
  baseStyle: {
    fontSize: "sm",
    fontWeight: "500",
    color: "blueGray.600",
  },
};

export default FormLabel;
